import React from "react"
import * as styles from "./Hover.module.css"
import classNames from "classnames"

type HoverProps = {
  children: React.ReactNode
  type: "scale"
}

const Hover = ({ children, type }: HoverProps) => {
  return (
    <div className={classNames({ [styles.scale]: type === "scale" })}>
      {children}
    </div>
  )
}

export default Hover
